import React, { CSSProperties, FC, useMemo, VFC } from "react";
import { ChatSnippet } from "components/ChatSnippet";
import { useSingleQueryParams } from "utils/url";

import style from "./WidgetSamplePage.scss";

export interface WidgetSamplePageProps {
    readonly widgetKey: string;
    readonly backgroundImage?: string;
    readonly backgroundColor?: string;
}

export const WidgetSamplePage: FC<WidgetSamplePageProps> = props => {
    const { widgetKey, backgroundImage, backgroundColor } = props;

    const bgStyle = useMemo<CSSProperties>(() => ({
        backgroundColor
    }), [backgroundColor]);

    return (
        <div className={style.samplePage}>
            {backgroundImage && <img src={backgroundImage} className={style.bgImg} alt="bg" />}
            {backgroundColor && <div style={bgStyle} className={style.bgImg} />}
            {widgetKey &&
                <ChatSnippet widgetKey={widgetKey} />
            }
        </div>
    );
};

export interface WidgetSamplePageQueryParams {
    readonly backgroundImage?: string;
    readonly backgroundColor?: string;
    readonly key: string;
}

export const WidgetSamplePageContainer: VFC = () => {
    const params = useSingleQueryParams<WidgetSamplePageQueryParams>({
        backgroundColor: q => {
            if (/^\d{6}$/.exec(q)) {
                return `#${q}`;
            }
            return q;
        },
        backgroundImage: q => q,
        key: q => q
    });
    return (
        <WidgetSamplePage
            widgetKey={params.key}
            backgroundImage={params.backgroundImage}
            backgroundColor={params.backgroundColor}
        />
    );
};
